import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const SEND_FILE_INVOICE = "SEND_FILE_INVOICE";
export const SEND_FILE_INVOICE_LOADING =
"SEND_FILE_INVOICE_LOADING";
export const SEND_FILE_INVOICE_LOADING_FAILED =
"SEND_FILE_INVOICE_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const sendFileInvoiceLoading = ms => ({
    type: SEND_FILE_INVOICE_LOADING,
    payload: ms
    });
    
    export const sendFileInvoiceLoadingFailed = ms => ({
    type: SEND_FILE_INVOICE_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function sendFileInvoice(obj) {
    const request = axios.post(
    `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/fileInvoices/sendFileInvoice`,obj,
    {
      headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
    });
    return dispatch => {

    dispatch(sendFileInvoiceLoading());
   console.log(request,"request")
    request
    .then(response => {   
      console.log(response,"response")   
    if (response.status == 200) {
     console.log(response,"response sendFileInvoice")
    dispatch({
    type: SEND_FILE_INVOICE,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        sendFileInvoiceLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(sendFileInvoiceLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(sendFileInvoiceLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(sendFileInvoiceLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


